import React, { useRef, useState } from 'react';
import { Alerta, Btn, Modal, Textarea } from './UI';
import { MINIMO_TEXTO_EVENTO, situacaoTextoEvento } from '../utils/textoEvento';

// Modal de evento com texto livre (cancelamento, CC-e). Conta os caracteres do
// texto como ele vai no XML, bloqueia o envio fora de 15..limite e trava o
// botão enquanto o pedido está na SEFAZ: o segundo clique de um clique duplo
// não dispara outro envio (a trava por ref vale mesmo antes de a tela redesenhar).
export default function ModalTextoEvento({
  titulo, aberto, onFechar, alerta, tipoAlerta = 'info', rotulo, limite,
  valor, onChange, onEnviar, rotuloBotao, variante = 'primary',
}) {
  const [enviando, setEnviando] = useState(false);
  const travado = useRef(false);
  const { n, ok, excedeu } = situacaoTextoEvento(valor, limite);

  const enviar = async () => {
    if (travado.current || !ok) return;
    travado.current = true;
    setEnviando(true);
    try {
      await onEnviar();
    } finally {
      travado.current = false;
      setEnviando(false);
    }
  };

  return (
    <Modal titulo={titulo} aberto={aberto} onFechar={enviando ? () => {} : onFechar} largura="450px">
      {alerta && <Alerta tipo={tipoAlerta}>{alerta}</Alerta>}
      <Textarea label={`${rotulo} (mín. ${MINIMO_TEXTO_EVENTO} caracteres)`} value={valor}
                onChange={onChange} disabled={enviando} />
      <div data-testid="contador" style={{ fontSize: '11px', textAlign: 'right', marginTop: '-10px', marginBottom: '10px',
                    color: excedeu ? '#B91C1C' : '#999', fontWeight: excedeu ? 600 : 400 }}>
        {n}/{limite}{excedeu ? ' — acima do limite, encurte o texto' : ''}
      </div>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <Btn variant="outline" onClick={onFechar} disabled={enviando}>Voltar</Btn>
        <Btn variant={variante} onClick={enviar} disabled={!ok || enviando}>
          {enviando ? 'Enviando à SEFAZ...' : rotuloBotao}
        </Btn>
      </div>
    </Modal>
  );
}
